export default __webpack_public_path__ + "static/media/mindesk.68d2f928.png";